<template>
  <div
    id="update"
    :class="[
      show ? 'show' : '',
    ]"
  >
    <div
      :class="[
        show ? 'show' : '',
        'card',
      ]"
    >
      <div class="card-header">
        <label class="header">
          Update Status as {{ status }}
        </label>
      </div>

      <div class="card-content">
        <div
          v-if="!displayUselessDiv"
          class="table-container"
        >
          <v-data-table
            :headers="headers"
            :items="allAlerts"
            show-select
            fixed-header
            hide-default-footer
            disable-pagination
            item-key="index"
            height="300px"
            @item-selected="selectAlerts"
            @toggle-select-all="selectAllAlerts"
          >
            <template #[`item.firstOccurred`]="{ item }">
              <td>
                <span>{{ formattedDate(item.firstOccurred) }}</span>
              </td>
            </template>
          </v-data-table>
        </div>
        <div
          v-else
          class="useless-div"
        >
          --
        </div>
      </div>
      <div class="card-footer">
        <div class="btn-container">
          <button
            class="cancel-btn"
            @click="hide(); reset()"
          >
            Cancel
          </button>
          <button
            :class="[
              'save-btn',
              !selectedAlerts.length ? 'disable' : '',
            ]"
            :disabled="!selectedAlerts.length"
            @click="updateAlertStatus(selectedAlerts, status); reset()"
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import _ from 'lodash';

export default {
  name: 'UpdateAlertStatus',
  props: {
    show: Boolean,
    hide: Function,
    status: String,
    allAlerts: Array,
    updateAlertStatus: Function,
  },
  data() {
    return {
      headers: [{
        text: 'Urgency',
        align: 'start',
        filterable: false,
        sortable: false,
        value: 'severity',
      }, {
        text: 'Status',
        align: 'start',
        filterable: false,
        sortable: false,
        value: 'status',
      }, {
        text: 'Category',
        align: 'start',
        filterable: false,
        sortable: false,
        value: 'category',
      }, {
        text: 'Alert Type',
        align: 'start',
        filterable: false,
        sortable: false,
        value: 'type',
      }, {
        text: 'First Occurred On',
        align: 'start',
        filterable: false,
        sortable: false,
        value: 'firstOccurred',
      }],
      selectedAlerts: [],
      displayUselessDiv: false,
      filteredAlerts: [],
    };
  },
  methods: {
    formattedDate(date) {
      if (date) {
        return moment(date).format('M-DD-YY | h:mmA');
      }
      return '--';
    },
    selectAlerts({ item, value }) {
      const alert = _.cloneDeep(item);
      if (value) {
        this.selectedAlerts.push(alert);
      } else {
        this.selectedAlerts = this.selectedAlerts.filter((a) => a.index !== alert.index);
      }
    },
    selectAllAlerts({ items, value }) {
      if (value) {
        this.selectedAlerts = [...items];
      } else {
        this.selectedAlerts = [];
      }
    },
    reset() {
      this.selectedAlerts = [];
      this.displayUselessDiv = true;
      // Use this until you find a method to unselect all
      setTimeout(() => {
        this.displayUselessDiv = false;
      }, 0);
    },
  },
};
</script>

<style lang="scss">

#update {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.3);
  align-items: center;
  justify-content: center;
  z-index: 5;
  transform: scale(0);
  &.show {
    display: flex;
    transform: scale(1);
  }
  .card {
    position: relative;
    width: 50vw;
    min-width: 500px;
    background-color: $WHITE;
    border-radius: 10px;
    transform: scale(0);
    transition: all .3s;
    &.show {
      transform: scale(1);
    }
    .card-header {
      padding: 10px;
      border-top-right-radius: 10px;
      border-top-left-radius: 10px;
      width: 100%;
      background-color: $CONTENTGRAY;
      font-size: 17px;
      font-weight: 600;
      color: $WHITE;
      text-transform: uppercase;
    }
    .card-content {
      padding: 20px;
      .table-container {
        .v-data-table__wrapper {
          thead {
            tr {
              th {
                background-color: $N1;
                color: $N65;
                font-size: 15px;
                font-weight: 600;
                text-transform: uppercase;
                .mdi-checkbox-blank-outline::before,
                .mdi-checkbox-marked::before,
                .mdi-minus-box::before,
                .mdi-arrow-up::before {
                  color: $N65;
                }
              }
            }
          }
          tbody {
            tr {
              td {
                border: 0;
              }
              &:hover {
                background: none;
              }
              &:nth-child(even) {
                background-color: $WHITE;
              }
            }
          }
        }
      }
    }
    .card-footer {
      display: grid;
      justify-content: flex-end;
      border-top: 1px solid $N10;
      padding: 10px;
      .btn-container {
        display: grid;
        grid-auto-flow: column;
        gap: 10px;
        .cancel-btn {
          padding: 5px 10px;
          font-size: 15px;
          border: 1px solid;
          border-radius: 4px;
          font-weight: 500;
        }
        .save-btn {
          padding: 5px 20px;
          font-size: 15px;
          border: 1px solid;
          border-radius: 4px;
          font-weight: 500;
          background-color: $N100;
          color: $WHITE;
        }
        .disable {
          background-color: $N20;
        }
      }
    }
  }
}
</style>
